module.exports = __webpack_public_path__ + "img/arrow-download.a8293d7b.svg";